import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        gap: theme.spacing(5),
        paddingBottom: theme.spacing(5),
    },
    list: { paddingTop: "0 !important" },
    warningBox: {
        backgroundColor: theme.palette.emteria.warning,
        display: "flex",
        gap: theme.spacing(2),
    },
    valueColumn: {
        paddingLeft: "1em",
    },
    capitalizedColumn: {
        display: "inline-block",
        "&::first-letter": {
            textTransform: "uppercase",
        },
    },
    switchLabel: {
        marginBottom: theme.spacing(1),
        fontWeight: 600,
    },
    switchBox: { display: "flex", alignItems: "center" },
    switchContent: { display: "flex", flexDirection: "column", marginLeft: theme.spacing(4) },
    resetSettingsContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
    },
    copyButton: {
        marginLeft: theme.spacing(3),
    },
    apiKeyContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "space-between",
    },
    apiKeyActions: {
        display: "flex",
        gap: theme.spacing(1),
    },
    versionDisplay: {
        color: "gray",
        fontSize: "12px",
        opacity: 0.6,
        marginTop: "auto",
    },
    formContainer: {
        width: "100%",
        padding: theme.spacing(3),
        paddingBottom: theme.spacing(5),
        overflow: "auto",
    },
    formGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: theme.spacing(3),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
        },
    },
    formField: {
        minWidth: 0,
        marginBottom: theme.spacing(3),
    },
    phoneRow: {
        display: "flex",
        gap: theme.spacing(1),
        alignItems: "flex-start",
        "& > *:first-of-type": { flex: "0 0 140px", minWidth: 0 },
        "& > *:last-of-type": { flex: 1, minWidth: 0 },
    },
    fullWidthSection: {
        gridColumn: "1 / -1",
    },
    sectionHeader: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(1),
        fontWeight: 600,
        fontSize: 16,
    },
    actionRow: {
        paddingTop: theme.spacing(5),
        display: "flex",
        justifyContent: "space-between",
    },
    formLabel: {
        fontSize: "16px",
    },
    tabPanel: {
        padding: 0,
    },
    tabPanelBilling: {
        padding: 0,
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(5),
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 420,
    },
    loadingBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120,
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    generateButton: {
        marginLeft: theme.spacing(3),
    },
    confirmDialogParagraph: {
        marginBottom: theme.spacing(2),
    },
    confirmDialogListTitle: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
    confirmDialogList: {
        margin: 0,
        paddingLeft: theme.spacing(3),
    },
    descriptionText: {
        marginBottom: theme.spacing(2),
    },
    formInfoText: {
        marginBottom: theme.spacing(1),
    },
    switcherBox: {
        width: 200,
    },
}));
